import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Phone } from 'lucide-react';

const team = [
  { name: 'Vimal George', role: 'Founder / CEO', bio: 'I am an ambitious workaholic, but apart from that, pretty simple person.', initials: 'VG', color: '#C9A84C' },
];

export default function TeamAndCTA() {
  return (
    <>
      <style>{`
        .team-section { background: var(--white); padding: 96px 0; }
        .team-header { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 52px; flex-wrap: wrap; gap: 20px; }
        .team-grid { display: flex; flex-wrap: wrap; justify-content: center; gap: 24px; }
        .team-grid .team-card { width: 300px; }
        .team-card { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; transition: all 0.28s ease; }
        .team-card:hover { box-shadow: var(--shadow-lg); transform: translateY(-5px); border-color: var(--gold); }
        .tc-avatar {
          height: 220px; display: flex; align-items: center; justify-content: center;
          position: relative; overflow: hidden;
        }
        .tc-avatar-bg { position: absolute; inset: 0; }
        .tc-initials {
          font-family: var(--font-display); font-size: 60px; font-weight: 700;
          color: rgba(255,255,255,0.18); position: relative; z-index: 1;
          user-select: none;
        }
        .tc-bar { position: absolute; bottom: 0; left: 0; right: 0; height: 4px; background: var(--gold); }
        .tc-info { padding: 24px 20px; }
        .tc-role { font-size: 11px; font-weight: 600; letter-spacing: 2px; text-transform: uppercase; color: var(--gold); margin-bottom: 5px; }
        .tc-name { font-family: var(--font-display); font-size: 20px; font-weight: 700; color: var(--text-dark); margin-bottom: 10px; }
        .tc-bio { font-size: 13px; line-height: 1.65; color: var(--text-light); margin-bottom: 16px; }
        .tc-links { display: flex; gap: 8px; }
        .tc-link { width: 32px; height: 32px; border-radius: 50%; border: 1px solid var(--border); display: flex; align-items: center; justify-content: center; color: var(--grey-400); transition: all 0.2s; cursor: pointer; }
        .tc-link:hover { background: var(--charcoal-dark); color: white; border-color: var(--charcoal-dark); }
        .tc-join { height: 220px; background: var(--gold-bg); border: 2px dashed rgba(201,168,76,0.35); border-radius: var(--radius) var(--radius) 0 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px; padding: 24px; text-align: center; }
        .tcj-title { font-family: var(--font-display); font-size: 18px; font-weight: 700; color: var(--text-dark); }
        .tcj-text { font-size: 13px; color: var(--text-light); }

        /* CTA band */
        .cta-band { background: var(--gold); padding: 64px 0; border-radius: var(--radius-lg) var(--radius-lg) 0 0; }
        .cta-band-inner { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 32px; }
        .ctab-title { font-family: var(--font-display); font-size: clamp(24px,3vw,38px); font-weight: 700; color: var(--charcoal-dark); line-height: 1.15; }
        .ctab-title em { font-style: italic; }
        .ctab-sub { font-size: 15px; font-weight: 300; color: rgba(42,42,42,0.7); margin-top: 6px; }
        .ctab-btns { display: flex; gap: 14px; flex-wrap: wrap; }
        .ctab-btn-dark { display: inline-flex; align-items: center; gap: 8px; padding: 14px 32px; background: var(--charcoal-dark); color: white; font-size: 13px; font-weight: 700; transition: all 0.25s; border: 2px solid var(--charcoal-dark); border-radius: var(--radius-sm); }
        .ctab-btn-dark:hover { background: white; color: var(--charcoal-dark); border-color: white; transform: translateY(-2px); }
        .ctab-btn-outline { display: inline-flex; align-items: center; gap: 8px; padding: 14px 32px; border: 2px solid rgba(42,42,42,0.4); color: var(--charcoal-dark); font-size: 13px; font-weight: 600; transition: all 0.25s; border-radius: var(--radius-sm); }
        .ctab-btn-outline:hover { border-color: var(--charcoal-dark); background: rgba(42,42,42,0.08); transform: translateY(-2px); }

        @media (max-width: 560px) { .team-grid .team-card { width: 100%; max-width: 340px; } }
      `}</style>

      <section className="team-section">
        <div className="container">
          <div className="team-header">
            <div>
              <span className="section-eyebrow">Our Team</span>
              <h2 className="section-title" style={{marginBottom:0}}>Creative Minds by <em>People Like You</em></h2>
            </div>
            <Link to="/who-we-are" className="btn-dark">
              Who We Are <ArrowRight size={14} />
            </Link>
          </div>

          <div className="team-grid">
            {team.map(({ name, role, bio, initials, color }) => (
              <div key={name} className="team-card">
                <div className="tc-avatar">
                  <div className="tc-avatar-bg" style={{background: `linear-gradient(135deg, ${color} 0%, ${color}88 100%)`}} />
                  <div className="tc-initials">{initials}</div>
                  <div className="tc-bar" />
                </div>
                <div className="tc-info">
                  <div className="tc-role">{role}</div>
                  <div className="tc-name">{name}</div>
                  <div className="tc-bio">{bio}</div>
                </div>
              </div>
            ))}
            <div className="team-card">
              <div className="tc-join">
                <div style={{fontSize:'40px'}}>🚀</div>
                <div className="tcj-title">Want a New Challenge?</div>
                <div className="tcj-text">Browse our job opportunities and join the family!</div>
              </div>
              <div className="tc-info">
                <div className="tc-role">Join Us</div>
                <div className="tc-name">View Open Jobs</div>
                <Link to="/contact" className="btn-dark" style={{fontSize:'12px',padding:'10px 20px',marginTop:'4px'}}>
                  Apply Now <ArrowRight size={12} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Band */}
      <div className="cta-band">
        <div className="container">
          <div className="cta-band-inner">
            <div>
              <div className="ctab-title">Ready to Take Control of<br /><em>Your Finances?</em></div>
              <div className="ctab-sub">Whether you have questions or you'd just like to say hello — we're here.</div>
            </div>
            <div className="ctab-btns">
              <a href="https://www.mytcs.com.au/" target="_blank" rel="noreferrer" className="ctab-btn-dark">
                <Calendar size={15} /> Book Appointment
              </a>
              <a href="tel:0469847803" className="ctab-btn-outline">
                <Phone size={14} /> 0469 847 803
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
